<template >
    <div>
    <span :class="`${class_name ? class_name : 'default-color'} detail-link`" @click="getDetail(row_id)">
        {{row_name}}
    </span>
	<slot/>
    </div>
</template>

<script>
export default {
   
	props:{
		row_name:{
			default(){return ''}
		},
		row_id:{
			default(){return 0}
		},
		row_type:{
			type:String,
			default(){return ''}
		},
		class_name: {
			type: String,
			default(){return ''},
		}
	},
	methods: {
		getDetail(row_id){
			this.rootGetDetail(row_id,this.row_type);
		}
	},
	inject: ['rootGetDetail'],
}
</script>
<style scoped>
.detail-link {
	font-weight: 500;
	cursor:pointer;
}
.default-color {
	color:#6164c1;
}
</style>


